module.exports = __webpack_public_path__ + "img/borussia-monchengladbach.f9fdb337.png";